/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon16Solid = forwardRef('XCircleIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.232 4.818a1 1 0 0 0-1.414 1.414L6.586 8 4.818 9.768a1 1 0 0 0 1.414 1.414L8 9.414l1.768 1.768a1 1 0 0 0 1.414-1.414L9.414 8l1.768-1.768a1 1 0 0 0-1.414-1.414L8 6.586 6.232 4.818Z" })));
});
